import { CheckCircle2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  resourceType: "delivery_note" | "invoice";
  resourceData?: {
    has_purchase_request?: boolean;
  };
  warnings?: string[];
  onConfirm: () => void;
}

const VALIDATION_MESSAGES = {
  invoice: {
    checklist: [
      "Los montos (subtotal, IVA, total) son correctos",
      "La condición de pago está identificada correctamente",
      "El proveedor está vinculado",
      "La fecha y número de factura son correctos"
    ],
    title: "Marcar factura como revisada"
  },
  delivery_note: {
    checklist: [
      "Las cantidades recibidas están correctas",
      "Todos los items están vinculados"
    ],
    title: "Marcar remito como revisado"
  }
};

export function MarkAsReviewedDialog({
  open,
  onOpenChange,
  resourceType,
  warnings = [],
  onConfirm
}: Props) {
  const messages = VALIDATION_MESSAGES[resourceType];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5" />
            {messages.title}
          </DialogTitle>
          <DialogDescription>
            Confirma que has revisado y validado los siguientes puntos:
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          {messages.checklist.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <CheckCircle2 className="h-4 w-4 text-green-600" />
              <span className="text-sm">{item}</span>
            </div>
          ))}
        </div>

        {warnings.length > 0 && (
          <div className="space-y-2">
            <h4 className="text-sm font-medium text-amber-700">Advertencias:</h4>
            {warnings.map((warning, index) => (
              <div key={index} className="flex items-center gap-2 text-sm text-amber-700">
                <span>•</span>
                <span>{warning}</span>
              </div>
            ))}
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={onConfirm}>
            Confirmar revisión
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}